import { render, staticRenderFns } from "./CombinationsProductDropdowns.vue?vue&type=template&id=1b492a81&scoped=true"
import script from "./CombinationsProductDropdowns.vue?vue&type=script&lang=ts"
export * from "./CombinationsProductDropdowns.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsProductDropdowns.vue?vue&type=style&index=0&id=1b492a81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b492a81",
  null
  
)

export default component.exports